import { render, staticRenderFns } from "./multimapMenu.vue?vue&type=template&id=f996bdc4"
import script from "./multimapMenu.vue?vue&type=script&lang=js"
export * from "./multimapMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports